import { Component, TemplateRef, OnInit } from '@angular/core';
import { UserPage } from '../models/login';
import { ApiService } from '../Services/api-service';
import { UserMasterResponse, User, hoUser, DepotsMst, TerritoryMst, GroupMst, DeptmntMst, DesigMst, ContractorMst, SalesMst, DealerContractorList, DealerCodeMst, DealercodeMst } from '../models/user';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/ngx-bootstrap-pagination';
import { ToastrService } from 'ngx-toastr';
import { NgForm, NgModel } from '@angular/forms';
import { Organisation, OrganisationResponse } from '../models/organisation';
import { DatePipe } from '@angular/common';
import { ExcelService } from '../excel.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ChipsModule } from 'primeng/chips';
import { splitAtColon } from '@angular/compiler/src/util';

@Component({
  selector: 'app-sales-person-onboarding',
  templateUrl: './sales-person-onboarding.component.html',
  styleUrls: ['./sales-person-onboarding.component.css']
})

export class SalesPersonOnboardingComponent implements OnInit {
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  pagesUser: UserPage = new UserPage();
  users: any[] = [];
  DealerList: any[] = [];
  currentPage: any;
  pagesuserorganisation: UserPage = new UserPage();
  modalhead: string = "Add User";
  modalRef: BsModalRef;
  mobileReg: RegExp = /^[6-9]\d{9}$/;
  emailReg: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  isEdit: boolean = true;
  HOuserReportlistexcel: any[] = []
  reportHoExcel: any[] = []
  totaldata: any;
  isUsrGroupError: boolean = false
  isDepartmentError: boolean = false
  showTerritory: boolean = false;
  isDesignationReportError: boolean = false
  isDesignationError: boolean = false
  isMobileError: boolean = false
  isEmailError: boolean = false
  isJoinDateError: boolean = false
  formval: hoUser = new hoUser();
  ReqDt: hoUser = new hoUser();
  newJoinDate: Date;
  DesigsList: DesigMst[] = [];
  DeptmntsList: DeptmntMst[] = [];
  DealerCodeList: DealerCodeMst[] = [];
  GroupsList: GroupMst[] = [];
  ContractorList: ContractorMst[] = [];
  SalesList: SalesMst[] = [];
  DealerNameList: DealerCodeMst[] = [];
  DepotsList: DepotsMst[] = [];
  isCheckedYes: boolean = false;
  isCheckedNo: boolean = false;
  TerritoryList: TerritoryMst[] = [];
  selectedAll: boolean = false;
  isEditpassword: boolean = false;
  isNoBussinessLine: boolean = false;
  isNoDepot: boolean = false;
  isNoTerritory: boolean = false;
  selectedAllT: boolean = false;
  buttonText: string = "Save";
  submitForm: NgForm;
  dnm: boolean = false;
  bussinessCheck: any;
  show: boolean = false;
  BusinessLine: any = [{ BussinessId: 1, BusinessNm: 'Retail', BusinessCd: 'R', selected: false },
  { BussinessId: 2, BusinessNm: 'Industrial', BusinessCd: 'I', selected: false },
  { BussinessId: 3, BusinessNm: 'Projects', BusinessCd: 'P', selected: false }];
  showContractorTemp: any;
  salespersonlist: any;
  isSalesPersonId: boolean = false;
  isContractorId: boolean = false;
  isDealerId: boolean = false;
  selectedContractors: DealerContractorList[] = [];
  selectedSalesPerson: any[] = [];
  selectedDealercode: any[] = [];
  isUserSales: boolean = false;
  userType: number = 0
  isterritoryData: boolean = false;
  DealerContractorSalespersonList: DealerContractorList[] = [];
  values2: any[] = [{ key: '1', value: 'one' }];
  key: string;
  value: string;
  isDisable: boolean = true;
  ContractorSelectedList: ContractorMst[] = [];
  issalesFieldDisabled: boolean = false;
  isContractorError: boolean = false;
  isSalesError: boolean = false;
  AdhaarCardPath: any;
  PANCardPath: any;
  isImageAvailable: boolean = true;
  showimage: any;
  ImageBase64: any
  url: any;
  showimage1: any;
  url1: any;
  IsActive: boolean;
  IsActive1: boolean;
  IsActive2: boolean;
  DealerCode: any;
  DealerName2: any;
  isDealerCodeDisabled: boolean = false;
  multivalue: boolean = false;
  ContractorSellerList: any;


  constructor(private excelService: ExcelService, private toastr: ToastrService, private apiService: ApiService, private modalService: BsModalService, private dt: DatePipe) {
    this.pagesUser.Filter = 'FirstName';
  }

  ngOnInit() {
    debugger;
    //this.formval.UsrGroup="0"
    //this.getDepots();
    //this.getDepartment(0);
    //this.getGroup(0);
    //this.getDesig(0);
    // this.getDealerCode(0);
    // this.getdealercodename(0)
    //this.getDealerCodeUser(this.pagesUser);
    //this.getContractor(0);
    //this.getSales(0);
    this.getUsers(this.pagesUser);
    //this.getDealercode1(this.pagesUser)
  }



  toDataURL = async (AdhaarCardPath) => {
    debugger
    console.log("Downloading image...");
    var res = await fetch(AdhaarCardPath);
    var blob = await res.blob();

    const result = await new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })

    return result
  };
  //AdhaarCardPath = await this.toDataURL(imageSrc)

  base64textString = [];

  onUploadChange(evt: any) {
    debugger;
    const file = evt.target.files[0];

    if (file) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        this.ImageBase64 = fileReader.result;
        this.showimage = this.ImageBase64
        //this.isImageSelected = true

      };
    }


  }

  handleReaderLoaded(e) {
    debugger
    this.showimage = ('data:image/png;base64,' + btoa(e.target.result));


  }
  onAdhaarUpload(event: any) {
    debugger;
    var fileReader = new FileReader();
    var mimeType = event.target.files[0].type;
    var path = (event.target.result)
    if (mimeType.match(/image\/*/) == null) {
      debugger
      this.formval.AdhaarCardPath;
      //  this.ngForm.patchValue({
      //   AdhaarCardPath: ''
      // })
      this.toastr.warning('Only images are supported.');
      this.ImageBase64 = '';
      this.formval.AdhaarCardPath = undefined;
      return;
    }
    else if (event.target.files[0].size > 2500000) {
      this.formval.AdhaarCardPath;

      this.toastr.error('', 'Image size is more than 2.5 MB Please reduce or select other');
      this.ImageBase64 = '';
      this.formval.AdhaarCardPath = undefined;
      return;
    }
    else {
      fileReader.readAsDataURL(event.target.files[0]);
      // console.log(event.target.files[0])
      // console.log(fileReader.result)
      fileReader.onload = () => {
        this.ImageBase64 = fileReader.result;
        this.showimage = this.ImageBase64;
        this.url = this.ImageBase64.split(',')[1].trim();
        //var result= this.ImageBase64.split(',')[1].trim();
        console.log(this.url);
        // this.isImageSelected = true

      };
    }
  }
  onPANUpload(event: any) {
    debugger;
    var fileReader = new FileReader();
    var mimeType = event.target.files[0].type;
    var path = (event.target.result)
    if (mimeType.match(/image\/*/) == null) {
      debugger
      this.formval.PANCardPath;
      //  this.ngForm.patchValue({
      //   AdhaarCardPath: ''
      // })
      this.toastr.warning('Only images are supported.');
      this.ImageBase64 = '';
      this.formval.PANCardPath = undefined;
      return;
    }
    else if (event.target.files[0].size > 2500000) {
      this.formval.PANCardPath;
      // this.formval.patchValue({
      //   AdhaarCardPath: ''
      // })
      this.toastr.error('', 'Image size is more than 2.5 MB Please reduce or select other');
      // this.tstr.error('', 'imagen mayor a 2.5MB por favor reducir resolucion ')
      this.ImageBase64 = '';
      this.formval.PANCardPath = undefined;
      return;
    }
    else {
      fileReader.readAsDataURL(event.target.files[0]);
      // console.log(event.target.files[0])
      // console.log(fileReader.result)
      fileReader.onload = () => {
        this.ImageBase64 = fileReader.result;
        this.showimage1 = this.ImageBase64;
        this.url1 = this.ImageBase64.split(',')[1].trim();
        //var result= this.ImageBase64.split(',')[1].trim();
        console.log(this.url1);
        // this.isImageSelected = true

      };
    }
  }

  DownloadHOUserReport() {
    debugger
    this.show = true;
    if (this.users != null) {
      this.pagesUser.UserType = 10;
      this.apiService.PostApi(this.pagesUser, "HOUser/GetAllSeller").subscribe((res: any) => {
        debugger
        this.HOuserReportlistexcel = res.ResponseData;
        console.log(this.HOuserReportlistexcel)
        this.reportHoExcel = this.reportHoExcel.slice(0, 0);
        this.HOuserReportlistexcel.forEach(o => {
          this.reportHoExcel.push(
            {
              // Employee_ID: o.EmpId,
              FirstName: o.FirstName,
              LastName: o.LastName,
              Mobile: o.Mobile,
              EmailID: o.Email,
              UserGroup: o.GroupNm,
              AdhaarNumber: o.AdhaarNo,
              PANCardNumber: o.PANCardNo,
              Status: o.IsActive,
              JoinDatet: o.JoinDt,
              UniqueCode: o.UniqueCode,
              DealerName: o.DealerName
            }
          )
        });
        this.exportAsXLSX(this.HOuserReportlistexcel)
      },
        err => {
          this.show = false;
          this.totaldata = 0;
        }
      )
    }
    this.show = false;
  }
  exportAsXLSX(HOuserReportlistexcel: any): void {
    this.excelService.exportAsExcelFile(this.reportHoExcel, 'Ho User Report')
  }
  onSelect() {

  }

  onSubmit(f: NgForm) {
    debugger;

    const dt = f.value;

    // Validate if passwords match
    if (dt.cpassword !== dt.Password) {
      this.dnm = true;
      return;
    } else {
      this.dnm = false;
    }

    // Set IsActive based on the form values
    if (this.formval.IsActive1 === true) {
      dt.IsActive = true;
    } else if (this.formval.IsActive2 === true) {
      dt.IsActive = false;
    } else {
      dt.IsActive = this.formval.IsActive;
    }

    // Validate required fields
    if (
      //!dt.FirstName ||
      !dt.Email ||
      !dt.fromdate ||
      !dt.AdhaarNo ||
      !dt.PANCardNo ||
      !this.url ||
      !this.url1
    ) {
      this.toastr.warning('Please fill all required details', 'Warning!', {
        timeOut: 1000,
      });
      return;
    }

    // Prepare the request payload
    // Prepare the request payload
    const reqDt = {
      ID: dt.ID ? dt.ID : this.formval.ID,
      FirstName: dt.firstname ? dt.firstname : '',
      LastName: dt.lastname ? dt.lastname : '',
      Email: dt.Email ? dt.Email : '',
      Password: dt.Password ? dt.Password : '',
      Mobile: dt.Mobile ? dt.Mobile : '',
      Address: dt.Address ? dt.Address : '',
      District: dt.District ? dt.District : '',
      Pin: dt.Pin ? dt.Pin : '',
      State: dt.State ? dt.State : '',
      City: dt.City ? dt.City : '',
      IsApproved: dt.IsApproved ? dt.IsApproved : false,
      OTP: dt.OTP ? dt.OTP : 0,
      EmpId: dt.EmpId ? dt.EmpId : '',
      AdhaarNo: dt.AdhaarNo ? dt.AdhaarNo : '',
      PANCardNo: dt.PANCardNo ? dt.PANCardNo : '',
      AdhaarCardPath: this.url ? this.url : '',
      PANCardPath: this.url1 ? this.url1 : '',
      JoinDate: dt.fromdate ? dt.fromdate : ''
    };

    console.log('Request Payload:', reqDt);

    // Call the API
    this.show = true;
    this.apiService.PostApi(reqDt, "HOUser/SaveNewSalesperson").subscribe(
      (response: any) => {
        debugger;
        if (response.ResponseCode == 200) {
          this.getUsers(this.pagesUser); // Refresh the user list
          this.resetmodal(); // Reset the modal
          this.show = false;

          this.toastr.success(response.ResponseMessage, 'Success!', {
            timeOut: 2000,
          });
        } else {
          this.toastr.warning(response.ResponseMessage, 'Warning!', {
            timeOut: 2000,
          });
          this.show = false;
        }
      },
      (err) => {
        this.toastr.warning(err.error.ResponseMessage, 'Error!', {
          timeOut: 2000,
        });
        this.show = false;
      }
    );
  }

  radioChange(value) {
    debugger
    if (value == 'Yes') {
      this.formval.IsActive1 = true;
      this.formval.IsActive2 = false
    }
    else if (value == 'No') {
      this.formval.IsActive2 = true;
      this.formval.IsActive1 = false
    }
  }
  onpagechange() {
    debugger;
    this.pagesUser.page = 1;
    this.getUsers(this.pagesUser);
  }
  getUsers(user: UserPage): any {
    debugger;

    this.show = true;
    this.pagesUser.UserType = 10;
    this.pagesUser.IsActive = '%';
    this.pagesUser.FilterBY = '';
    this.apiService.PostApi(this.pagesUser, "HOUser/GetAllSeller").subscribe((response: any) => {
      debugger
      if (response.ResponseCode == "200") {
        this.users = response.ResponseData;
        console.log('userlist', this.users);
        this.totaldata = response.ResponseData[0].TotalCount;
        if (this.pageSizeOptions.indexOf(this.totaldata) === -1) {
          this.pageSizeOptions = [...this.pageSizeOptions, this.totaldata];
        }
        // if (this.totaldata < parseInt(this.pagesUser.pageSize)) {
        //   this.currentPage = 1;
        // }
      }
      else {
        this.users = null;
        this.show = false;
      }
    }, err => {
      //this.users = null;
      this.show = false;
    });
    this.show = false;
  }

  pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.pagesUser.page = event.page;
    this.getUsers(this.pagesUser);
    this.currentPage = event.page + 1;
  }



  getDealernameoncode(DealerCode: any): any {
    debugger;
    // var obj = DealerCode.value
    var obj = DealerCode.value.DealerCode    //for p-dropdown
    this.apiService.GetApi(obj, "HOUser/GetDealernameweb?dealercode=" + obj).subscribe((response: any) => {
      debugger;
      if (response.ResponseCode == "200") {
        this.DealerNameList = response.ResponseData;
        this.formval.DealerName = response.ResponseData[0].DealerName;
        this.formval.DealerCode = response.ResponseData[0].DealerCode;
      }
      else {
        this.DealerNameList = null;
      }
    }, err => {
      this.DealerNameList = null;
    });
  }


  getContractor(UserId: number): any {

    this.show = true;

    this.apiService.GetApi(UserId, "HOUser/GetContractorForDdl?UserId=" + UserId).subscribe((response: any) => {
      debugger;
      if (response.ResponseCode == "200") {
        this.ContractorList = response.ResponseData;
      }
      else {
        this.ContractorList = null;

        this.show = false;
      }
    }, err => {
      this.ContractorList = null;

      this.show = false;
    });

    this.show = false;
  }
  getDealerCodeUser(UserId) {
    debugger;
    this.apiService.getApi("HOUser/GetDealerCodeUser?userid=" + UserId).subscribe((response: any) => {
      debugger;
      if (response.ResponseCode == "200") {
        this.DealerCodeList = response.ResponseData;
        this.DealerCode = response.ResponseData.DealerCode
      }
      else {
        this.DealerCodeList = null;

        this.show = false;
      }
    },
      err => {

      });
  }




  resetmodal() {
    debugger;
    this.modalhead = "Add User";
    this.dnm = false;
    this.formval.UsrGroup = "0";
    this.selectedContractors = null;
    this.selectedSalesPerson = null;
    // this.selectedDealercode=null;
    this.SalesList = null;
    this.ContractorList = null;
    this.isDealerId = false;
    this.isSalesPersonId = false;
    this.isContractorId = false;
    this.isNoBussinessLine = false;
    this.isNoDepot = false;
    this.isNoTerritory = false;
    this.isEdit = true;
    this.formval.EmpId = '';
    this.formval.UsrGroup = '';
    this.formval.UsrDeptmnt = '';
    this.formval.UsrDesigForRpt = '';
    this.formval.UsrDesig = '';
    this.formval.FirstName = '';
    this.formval.LastName = '';
    this.formval.DealerCode = '';
    this.formval.selectedDealercode = '';
    this.formval.DealerName = '';
    this.formval.Email = '';
    this.formval.Mobile = '';
    this.formval.fromdate = null;
    this.formval.Password = '';
    this.formval.cpassword = '';
    this.formval.AdhaarNo = '';
    this.formval.PANCardNo = '';
    this.formval.AdhaarCardPath = '';
    this.formval.PANCardPath = '';
    this.url = '';
    this.url1 = '';
    this.showimage = '';
    this.showimage1 = '';
    this.formval.IsActive1 = true;
    this.formval.IsActive2 = false;
    this.formval.IsActive = true;
    this.selectedAll = false;
    this.selectedAllT = false;
    this.isUsrGroupError = false
    this.isDepartmentError = false
    this.isDesignationReportError = false
    this.isDesignationError = false
    this.isJoinDateError = false
    this.isterritoryData = false;
    this.isSalesError = false;
    this.multivalue = false;




    this.buttonText = "Save";
    this.modalRef.hide();
  }

  selectAll() {
    for (var i = 0; i < this.DepotsList.length; i++) {
      this.DepotsList[i].selected = this.selectedAll;
    }
  }
  checkIfAllSelected() {
    this.selectedAll = this.DepotsList.every(function (item: any) {
      return item.selected == true;
    })
  }

  selectAllT() {
    for (var i = 0; i < this.TerritoryList.length; i++) {
      this.TerritoryList[i].selected = this.selectedAllT;
    }
  }
  checkIfAllSelectedT() {
    this.selectedAllT = this.TerritoryList.every(function (item: any) {
      return item.selected == true;
    })
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  alphaOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return true;
    }
    return false;
  }
  spaceNotAllowed(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode == 32) {
      return false;
    }
    return true;
  }


  edituser(template, user) {
    debugger
    if (user.UsrGroup == "1") {

      this.isUserSales = true;
      this.SalesList = null;
      this.isDealerId = false;
      this.isContractorId = false;
      this.isSalesPersonId = false;
      //this.formval.ContratorList = null;
      //this.formval.SalesList = null;
      this.formval.selectedSalesPerson = null;
      this.selectedContractors = null;
      this.isterritoryData = true
      this.isDisable = false;
      this.issalesFieldDisabled = false;
    }



    this.showTerritory = true
    for (var i = 0; i < this.DepotsList.length; i++) {
      this.DepotsList[i].selected = false;
    }
    for (var i = 0; i < this.BusinessLine.length; i++) {
      this.BusinessLine[i].selected = false;
    }
    this.modalhead = "New Sales Person Registration"
    this.isEditpassword = true;
    if (user.IsActive == true) {
      this.isCheckedYes = true;
      this.isCheckedNo = false;
      this.formval.IsActive1 = true;
      this.formval.IsActive2 = false
    }
    else if (user.IsActive == false) {
      this.isCheckedNo = true;
      this.isCheckedYes = false;
      this.formval.IsActive1 = false
      this.formval.IsActive2 = true
    }
    // user.JoinDt=this.dt.transform(user.JoinDt, 'MM/dd/yyyy');
    var ut = Object.values(user)[0];
    this.formval = { ...user };
    debugger;
    if (Object.values(user)[0] == '2') {
      this.formval.UsrGroup = "2"
    }

    this.formval = { ...user };
    this.isImageAvailable = true;
    this.showimage = user.AdhaarCardPath;
    this.showimage1 = user.PANCardPath;
    this.formval.ID = user.ID;
    this.formval.FirstName = user.FirstName;
    this.formval.DealerCode = user.UniqueCode;
    this.formval.DealerName = user.DealerName;
    this.formval.DeptId = user.DeptId;
    this.formval.EmpId = user.EmpId
    this.formval.LastName = user.LastName;
    this.formval.UsrGroup = user.UsrGroup;
    this.formval.UsrDeptmnt = user.UsrDeptmnt;
    this.formval.UsrDesigForRpt = user.UsrDesigForRpt;
    this.formval.Email = user.Email;
    this.formval.Mobile = user.Mobile;
    this.formval.UsrDesig = user.UsrDesig;
    // this.formval.fromdate = new Date(dateConcat);
    this.formval.IsActive = user.IsActive;
    this.formval.cpassword = user.Password;
    this.formval.Password = user.Password;
    this.formval.AdhaarNo = user.AdhaarNo;
    this.formval.PANCardNo = user.PANCardNo;
    this.formval.AdhaarCardPath = user.AdhaarCardPath;
    this.formval.PANCardPath = user.PANCardPath;
    this.formval.selectedSalesPerson = user.SalesId;
    this.formval.selectedDealercode = user.UniqueCode;
    let config = { backdrop: true, ignoreBackdropClick: true, class: 'modal-lg' };
    this.modalRef = this.modalService.show(template, config);
    //this.getTerritoryBuissnessData(user.ID);
    // this.getSalesByContractor(user.ID)
    // this.getSales(user.ID);

  }

  openModal(template: TemplateRef<any>) {
    debugger
    let config = { backdrop: true, ignoreBackdropClick: true, class: 'modal-lg' };
    this.formval.IsActive = true;
    this.formval.UsrDeptmnt = "0";
    this.formval.UsrDesig = "0";
    this.formval.UsrGroup = "0";
    this.formval.UsrDesigForRpt = "0";
    this.formval.ID = null;
    this.isCheckedYes = true;
    this.isCheckedNo = false;
    this.formval.IsActive1 = true;
    this.formval.IsActive2 = false;
    this.formval.selectedDealercode = ""
    this.isDealerCodeDisabled = false;
    for (var i = 0; i < this.BusinessLine.length; i++) {
      this.BusinessLine[i].selected = false;
    }
    this.isEditpassword = false;
    this.modalRef = this.modalService.show(template, config);
  }
}